import getAuthenticatedJSON from "../../utils/functions/getAuthenticatedJSON";
import axios from "axios";
export const GET_LOG_JOBS_MENU_URL = "#";
export const SIGN_OUT_URL = "login/login";
import {config as mainConfig} from '../../../../src/config/config'

let myConfig = Object.assign(mainConfig);

export function get_api_server() {
    return myConfig.baseUrl + 'bpmsback/api/1.0/' + myConfig.workspace + '/';
}
//Deprecated
export function get_current_notifications(apiServer) {
    return getAuthenticatedJSON(apiServer + "casesextend/my-todo-list")
}

export function get_my_name(apiServer) {
    return getAuthenticatedJSON(apiServer + "userextend/get-my-name")
}

export function get_my_permissions(apiServer,) {
    return getAuthenticatedJSON(apiServer + "arian/get-my-permissions")
}

export function sign_out(iframeServer) {
    return getAuthenticatedJSON(iframeServer+SIGN_OUT_URL)
}

export function get_tag_list(apiServer,) {
    return getAuthenticatedJSON(apiServer + "tag/tags-list")
}

export function get_menu_items(lang = 'fa') {
    return getAuthenticatedJSON(get_api_server() + "biarian/bibpmsmenucustome")
}

export function get_new_menu_items(apiServer,action) {
    return getAuthenticatedJSON(apiServer + "biarian/menu-structure?action="+action)
}

export function get_log_jobs() {
    return axios.get(GET_LOG_JOBS_MENU_URL, {crossdomain: true})
}

export function get_sso_info(apiServer){
    return getAuthenticatedJSON(apiServer + "sso/auth/sso-get-info")
}

export function get_active_languages(apiServer,) {
    return getAuthenticatedJSON(apiServer + "arian/get-actives-languages")
}

export function get_inbox_filters(apiServer,action) {
    return getAuthenticatedJSON(apiServer + "biarian/inbox-filters"+'/'+action)
}